// extracted by mini-css-extract-plugin
module.exports = {"heroBannerSpacer":"SearchPanelWrapper_heroBannerSpacer__XE8h5","form":"SearchPanelWrapper_form__yHXFP"};